import React, { useCallback } from 'react'

import { JoinUsTodayForm } from 'Components/Blocks/Forms'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Column, Modal, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { Container } from './styles'

type Props = {
  isOpened?: boolean
  onClose?: () => void
}

function JoinUsModalModal({ isOpened, onClose }: Props) {
  const { isMobile } = useResponsiveLayout()

  const handleClose = useCallback(() => {
    onClose?.()
  }, [onClose])

  if (!isOpened) return null

  return (
    <Modal isOpen onClose={handleClose}>
      <Container
        flexDirection={isMobile ? 'column' : 'row'}
        maxWidth={['90dvw', '90dvw', '90dvw', '90dvw', '820px']}
        p={[5, 5, 7, 7, 9]}
      >
        <Column alignCenter width={[1, 1, 1 / 2]}>
          <SubsectionTitle
            centered={isMobile}
            subtitle="Contact us to learn more about membership"
            title="Get in touch"
          />

          <Text
            body
            center={isMobile}
            mt={5}
            screen14={isMobile}
            screen18={!isMobile}
          >
            Get directly in touch with our team to help assist with your
            enquiry. Please provide as much detail as possible to help resolve
            your matter as quickly as we can.
          </Text>
        </Column>

        <Column width={[1, 1, 1 / 2]}>
          <JoinUsTodayForm onSubmit={handleClose} />
        </Column>
      </Container>
    </Modal>
  )
}

export default JoinUsModalModal
